import { render, staticRenderFns } from "./ReminderButton.vue?vue&type=template&id=9ac81d06"
import script from "./ReminderButton.vue?vue&type=script&lang=js"
export * from "./ReminderButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports